<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  import { v4 as uuidv4 } from 'uuid'

  export let label
  export let name
  export let required = true
  export let value = ''
  export let type = 'text'

  const ID = uuidv4()
  const ID_ERROR = `${ID}_err`

  let isBlurredOnce = false
  let isInvalid = false

  function validateAndEmit(e) {
    if (!isBlurredOnce) return

    value = type.match(/^(number|range)$/)
      ? +e.target.value
      : e.target.value;

    if (!value && required) {
      isInvalid = true

      return
    }

    isInvalid = false
    dispatch('update', value)
  }
</script>

<div class="input-group">
  <label for={ID}>{ label }</label>
  <input
    id={ID}
    {name}
    {value}
    {type}
    aria-describedby={isInvalid ? ID_ERROR : null}
    on:blur|once={() => isBlurredOnce = true }
    on:input={validateAndEmit}
    on:blur={validateAndEmit}
  >
  {#if isBlurredOnce && isInvalid }
    <p class="error-message" id={ID_ERROR}>{label} ist erforderlich.</p>
  {/if}
</div>

<style>
input {
  border: 1px solid var(--clr-blue-l70);
  font-size: inherit;
  padding: 0.25em;
  width: 40ch;
}

.error-message {
  color: var(--clr-error-text);
  margin-top: 0.25rem;
}
</style>